import React from 'react';
import { useAppStore } from "../../../GlobalStore/GlobalStore.ts";
import SelectionCheckbox from "../../Common/SelectionCheckbox";
import { getRelativePath } from '../../../Utils/misc/pathUtils';

interface FileItemProps {
    fileStatus: any;
    focusedFile: string | null;
    isLastItem: boolean;
    isFirstFileItem?: boolean;
    isInSelectedContext?: boolean;
    hasContextItems?: boolean;
}

const FileItem: React.FC<FileItemProps> = ({
    fileStatus,
    isLastItem,
    focusedFile,
    isFirstFileItem,
    isInSelectedContext,
    hasContextItems
}) => {
    const updateOpenFileStatuses = useAppStore((state: any) => state.updateOpenFileStatuses);
    const projectName = useAppStore((state: any) => state.environmentObj.projectName);
    const fileName = fileStatus.filePath.split(/[/\\]/).pop() || '';
    const isFocused = focusedFile === fileStatus.filePath;
    const relativePath = getRelativePath(fileStatus.filePath, projectName);

    const handleToggle = (e: React.MouseEvent) => {
        e.stopPropagation();
        updateOpenFileStatuses({
            filePath: fileStatus.filePath,
            isSelected: !fileStatus.isSelected
        }, "toggle");
    };

    return (
        <div
            onClick={handleToggle}
            className={`flex items-center justify-between px-4 py-2 text-black dark:text-white hover:bg-neutral-200 dark:hover:bg-neutral-800 
                ${isFirstFileItem && hasContextItems ? 'border-t-2 border-t-neutral-300 dark:border-t-neutral-700' : ''}
                ${!isLastItem ? 'border-b border-b-neutral-300 dark:border-b-neutral-700' : ''}`}
            data-tooltip-id="main-tooltip"
            data-tooltip-content={relativePath}
            data-tooltip-place="right-start"
        >
            <span className="text-sm max-w-3/4 overflow-hidden text-ellipsis whitespace-nowrap block" style={{ direction: 'rtl', textAlign: 'left' }}>
                <span style={{ direction: 'ltr', display: 'inline-block' }}>
                    {fileName}
                </span>
            </span>
            <SelectionCheckbox
                isSelected={fileStatus.isSelected}
                onChange={handleToggle}
                isFocused={isFocused || isInSelectedContext}
                focusedTooltip={isInSelectedContext ? "File is in selected context" : "Focused file"}
            />
        </div>
    );
};

export default FileItem;